const API_BASE_URL = 'https://hosting-visioner7.com/api/v1_apibbva';

export const authService = {
    async login(email, password) {
        try {
            /// console.log('Intentando login con:', { email, password });

            const response = await fetch(`${API_BASE_URL}/login.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                mode: 'cors', // Añadir explícitamente modo CORS
                body: JSON.stringify({
                    email,
                    password
                })
            });

            /// console.log('Response status:', response.status);
            /// console.log('Response ok:', response.ok);

            // Verificar si la respuesta es JSON válido
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                const text = await response.text();
                console.error('Respuesta no JSON:', text);
                return {
                    success: false,
                    error: 'El servidor respondió con un formato inválido'
                };
            }

            const data = await response.json();
            /// console.log('Datos recibidos:', data);

            if (data.success) {
                // Guardar token y datos del usuario en localStorage o cookies
                localStorage.setItem('auth_token', data.session_token);
                localStorage.setItem('user', JSON.stringify(data.usuario));

                return {
                    success: true,
                    user: data.usuario,
                    token: data.session_token
                };
            } else {
                return {
                    success: false,
                    error: data.message || 'Error en el inicio de sesión'
                };
            }
        } catch (error) {
            console.error('Error en login:', error);
            console.error('Error stack:', error.stack);

            // Detectar el tipo específico de error
            let errorMessage = 'Error de conexión con el servidor';

            if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
                errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión a internet o que el servidor esté disponible.';
            }

            return {
                success: false,
                error: errorMessage
            };
        }
    },

    async register(userData) {
        try {
            /// console.log('Intentando registro con:', userData);

            const response = await fetch(`${API_BASE_URL}/register.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                mode: 'cors',
                body: JSON.stringify({
                    email: userData.email,
                    password: userData.password,
                    nombre: userData.firstName,
                    apellido: userData.lastName,
                    telefono: userData.phone || '',
                    nombre_empresa: userData.company || '',
                    logo_empresa: userData.logo_empresa || 'https://via.placeholder.com/150'
                })
            });

            /// console.log('Response status (register):', response.status);

            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                const text = await response.text();
                console.error('Respuesta no JSON (register):', text);
                return {
                    success: false,
                    error: 'El servidor respondió con un formato inválido'
                };
            }

            const data = await response.json();
            /// console.log('Datos recibidos (register):', data);

            if (data.success) {
                return {
                    success: true,
                    message: data.message
                };
            } else {
                return {
                    success: false,
                    error: data.message || 'Error en el registro'
                };
            }
        } catch (error) {
            console.error('Error en registro:', error);
            return {
                success: false,
                error: 'Error de conexión con el servidor'
            };
        }
    },

    logout() {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
    },

    getCurrentUser() {
        const userStr = localStorage.getItem('user');
        try {
            return userStr ? JSON.parse(userStr) : null;
        } catch (e) {
            console.error('Error parsing user data:', e);
            return null;
        }
    },

    getAuthToken() {
        return localStorage.getItem('auth_token');
    },

    isAuthenticated() {
        const token = localStorage.getItem('auth_token');
        return !!token && token.length > 10; // Verificar que el token tenga longitud mínima
    }
};